function modalStart() {

    var stopVideosAndRefreshFrames = function () {
        var videos = document.querySelectorAll('iframe, video');
        Array.prototype.forEach.call(videos, function (video) {
            if (video.tagName.toLowerCase() === 'video') {
                video.pause();
            } else {
                var src = video.src;
                video.src = src;
            }
        });
    };
    
    function queryParameters () {
        var result = {};
    
        var params = window.location.search.split(/\?|\&/);
    
        params.forEach( function(it) {
            if (it) {
                var param = it.split("=");
                result[param[0]] = param[1];
            }
        });
    
        return result;
    }

    // Lets start the modals
    MicroModal.init({awaitCloseAnimation:true,onClose: modal => stopVideosAndRefreshFrames()});

    var url_parts = queryParameters();
    if (url_parts["show-video"]) {
        MicroModal.show("modal-video");
    }
    if (url_parts["show-map"]) {
        MicroModal.show("modal-map");
    }

    document.querySelectorAll(".modal__close").forEach(function(closeBtn){
        closeBtn.onclick = function(event) {
            var openModal = document.querySelector('.modal-odyssey.is-open');
            MicroModal.close(""+openModal.id);
        }
    });

    // MicroModal.show('modal-video');
    // MicroModal.init({
    //   onShow: modal => console.info(`${modal.id} is shown`), // [1]
    //   onClose: modal => console.info(`${modal.id} is hidden`), // [2]
    //   openTrigger: 'data-custom-open', // [3]
    //   closeTrigger: 'data-custom-close', // [4]
    //   openClass: 'is-open', // [5]
    //   disableScroll: true, // [6]
    //   disableFocus: false, // [7]
    //   awaitOpenAnimation: false, // [8]
    //   awaitCloseAnimation: false, // [9]
    //   debugMode: true // [10]
    // });
    // https://micromodal.now.sh/
}

export default modalStart;